var render = function render() {
  var _vm$store$formTomador, _vm$store$formTomador2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    attrs: {
      "align-h": "end"
    }
  }, [_vm.simplificadaToImport.length ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.importarSimplificada",
      modifiers: {
        "importarSimplificada": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Somente irá importar as OS: Autorizadas, Finalizadas, Em andamento e Serviço concluído',
      expression: "\n          'Somente irá importar as OS: Autorizadas, Finalizadas, Em andamento e Serviço concluído'\n        ",
      modifiers: {
        "top": true
      }
    }],
    ref: "import-orcamento-button",
    staticClass: "btn btn-primary font-weight-bold mr-2",
    staticStyle: {
      "height": "38px",
      "margin-bottom": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v(" Importar OS Simp. ")]) : _vm._e(), _vm.osToImport.length ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.importarOS",
      modifiers: {
        "importarOS": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Somente irá importar as OS: Autorizadas, Finalizadas, Em andamento e Serviço concluído',
      expression: "\n          'Somente irá importar as OS: Autorizadas, Finalizadas, Em andamento e Serviço concluído'\n        ",
      modifiers: {
        "top": true
      }
    }],
    ref: "import-orcamento-button",
    staticClass: "btn btn-primary font-weight-bold mr-2",
    staticStyle: {
      "height": "38px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(" Importar OS ")]) : _vm._e()]), _c('b-card', [_c('b-tabs', {
    attrs: {
      "pills": "",
      "horizontal": _vm.windowWidth < 768,
      "vertical": _vm.windowWidth > 768,
      "nav-wrapper-class": _vm.windowWidth > 768 ? 'w-25' : 'w-100',
      "fill": ""
    }
  }, [_c('Tomador'), _c('Servicos'), _c('Pagamento')], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveNfse ? _c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    ref: "submit_nova_nfse",
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.salvarNfse
    }
  }, [_vm._v(" Salvar ")]), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTransmitirNfse",
      modifiers: {
        "modalTransmitirNfse": true
      }
    }],
    staticClass: "btn btn-secondary font-weight-bold mx-2"
  }, [_vm._v(" Transmitir ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'nfseServicos'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)]) : _c('div', [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'nfseServicos'
      }
    },
    on: {
      "click": function click() {
        _vm.store.dataFetched = false;
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1), _c('b-modal', {
    attrs: {
      "id": "modalTransmitirNfse",
      "title": "Transmissão",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          ref: "transmitir_nfse",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.transmitirNFse
          }
        }, [_vm._v(" Transmitir ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "d-flex flex-column mx-auto",
    staticStyle: {
      "gap": "0.5rem"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "emailToSendNfse",
      "label-for": "emailToSendNfse",
      "label": "Email para enviar a NFSe"
    }
  }, [((_vm$store$formTomador = _vm.store.formTomador) === null || _vm$store$formTomador === void 0 || (_vm$store$formTomador = _vm$store$formTomador.emails) === null || _vm$store$formTomador === void 0 ? void 0 : _vm$store$formTomador.length) === 0 ? _c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.emailToSendNfse,
      callback: function callback($$v) {
        _vm.emailToSendNfse = $$v;
      },
      expression: "emailToSendNfse"
    }
  }) : _c('b-form-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: _vm.emailToSendNfse,
      callback: function callback($$v) {
        _vm.emailToSendNfse = $$v;
      },
      expression: "emailToSendNfse"
    }
  }, _vm._l((_vm$store$formTomador2 = _vm.store.formTomador) === null || _vm$store$formTomador2 === void 0 ? void 0 : _vm$store$formTomador2.emails, function (email) {
    return _c('b-form-select-option', {
      key: email.id_pessoa_email + 'plano_contas',
      attrs: {
        "value": email.email
      }
    }, [_vm._v(" " + _vm._s(email.email) + " ")]);
  }), 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('CheckBox', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: _vm.checkNutsDigital(),
      expression: "checkNutsDigital()"
    }],
    attrs: {
      "disabled": !_vm.canGenerateBoleto,
      "label": "Gerar boleto"
    },
    model: {
      value: _vm.generateBoleto,
      callback: function callback($$v) {
        _vm.generateBoleto = $$v;
      },
      expression: "generateBoleto"
    }
  })], 1)], 1)], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "importarSimplificada",
      "title": "Importar OS Sim.",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          ref: "importar_os",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.importarOSSimplificada
          }
        }, [_vm._v(" Importar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "OS",
      "label-for": "os"
    }
  }, [_c('VueSelect', {
    ref: "os",
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.simplificadaToImport
    },
    on: {
      "search": _vm.onSearchOS
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedOS,
      callback: function callback($$v) {
        _vm.selectedOS = $$v;
      },
      expression: "selectedOS"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a OS")])], 2)], 1)], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "importarOS",
      "title": "Importar OS",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('b-button', {
          ref: "importar_os",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.importarOS
          }
        }, [_vm._v(" Importar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "OS",
      "label-for": "os"
    }
  }, [_c('VueSelect', {
    ref: "os",
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.osToImport
    },
    on: {
      "search": _vm.onSearchOS
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedOS,
      callback: function callback($$v) {
        _vm.selectedOS = $$v;
      },
      expression: "selectedOS"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a OS")])], 2)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };